﻿const selector = '[data-count]';
const characterCountAttribute = 'data-characters-count'

const defaultOptions = {
  inputSelector: 'input',
  direction: '>=',
  limitClass: 'limit-reached',
  hardLimit: false,
  delay: 100
}

const elements = document.querySelectorAll(selector);

elements.forEach((element) => {
  let options = { ...defaultOptions, ...JSON.parse(element.dataset.count) };
  let input = element.querySelector(options.inputSelector);

  updateCount(element, input, options);

  let inDebounce;
  input.addEventListener('keyup', function () {

	clearTimeout(inDebounce);
	inDebounce = setTimeout(function () {
	  updateCount(element, input, options);
	}, options.delay);
  });
});

function updateCount(element, input, options) {

  let charactersCount = input.value.length;
  if (options.hardLimit && charactersCount > options.limit) {
	input.value = input.value.substring(0, options.limit);
	charactersCount = input.value.length;
  }

  element.setAttribute(characterCountAttribute, `${charactersCount}/${options.limit}`);

  let force = false;
  switch (options.direction) {
	case '<':
	  force = charactersCount < options.limit;
	  break;
	case '<=':
	  force = charactersCount <= options.limit;
	  break;
	case '>=':
	  force = charactersCount >= options.limit;
	  break;
	  force = charactersCount > options.limit;
	case '>':
	  break;
  }

  element.classList.toggle(options.limitClass, force);
}